<template>
  <div class="container-fluid advanced-filter-container">
    <div class="row">
      <div class="col-sm-11 from-top">
          <form v-on:submit.prevent>
            <p class="advanced-filter-title">Advanced Search</p>
            <div class="row" v-for="(fields, title) in filters">
              <div class="col-sm-3" >
                <input class="field" :value="title" disabled>
              </div>
              <div class="col-sm-2 dynamic-field" v-for="field in fields">
                <input type="text" :placeholder="field" class="field" :name="generateName(title,field)">
              </div>
              <button :id="title" @click="removeFilter($event)" class="remove-filter">
                <img class="remove-filter-img" src="../assets/cross.svg" alt="">
              </button>
            </div>
            <div class="row">
              <div class="col-sm-3">
                <select class="select-style"  name="advanced-dropdown" id="advanced-dropdown" v-model="selected">
                  <option disabled selected value> select a filter  </option>
                  <option v-for="option in options" :value="option">{{ option }}</option>
                </select>
              </div>
            </div>
            <div class="row static-section">
              <div class="col-sm-2">
                 <p class="advanced-filter-title">Policy</p>
              <div><input type="text" class="field" placeholder="Policy Number" name="Policy@policy_number"></div>
              </div>
              <div class="col-sm-2">
                 <p class="advanced-filter-title">Quotation</p>
                <div>
                  <input type="text" class="field" placeholder="Quotation Number" name="Quotation@quotation_number">
                </div>
              </div>
              <div class="col-sm-8">
                 <p class="advanced-filter-title">Vehicle</p>
                <div class="row">
                  <div class="col-sm-3">
                    <input type="text" class="field" placeholder="Vin / Chasis" name="Vehicle@vin">
                  </div>
                  <div class="col-sm-3">
                    <input type="text" class="field" placeholder="License Plate" name="Vehicle@license_plate">
                  </div>

                </div>
              </div>
            </div>
            <button @click="search()" class="advanced-search">Search</button>
          </form>
      </div>
      <div class="col-sm-1 from-top">
        <button @click="toggleAdvancedFilter()" class="close-advanced-filter"><img src="../assets/close.svg" alt=""></button>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import store from '../store.js';
export default{
    watch: {
      selected: function(val){
        this.filters[val] = this.advancedFilterConfig.config[val];
      }
    },
    created(){
      for (var key in this.advancedFilterConfig) {
        if (this.advancedFilterConfig.hasOwnProperty(key)) {
          for (var deepKey in this.advancedFilterConfig[key]) {
            // var arr = this.advancedFilterConfig[key][deepKey];
            this.payload[deepKey.toLowerCase()] = {};
          }
        }
      }
    },
    data(){
        return {
          payload: {},
          filters: {},
          selected: '',
          advancedFilterConfig: {
            'config': {
              'Customer': ['First Name', 'Last Name', 'Government ID', 'Email'],
              'Co-Owner': ['First Name', 'Last Name', 'Government ID', 'Email'],
              'Driver': ['First Name', 'Last Name', 'Government ID', 'Email']
            },
            'static': {
              'Policy': ['Policy Number'],
              'Quotation': ['Quotation Number'],
              'Vehicle': ['VIN / Chasis', 'License Plate']
            }
          }
        };
    },
    computed: {
      fields: function(){
        return this.advancedFilterConfig.config[this.selected];
      },
      options: function(){
        return Object.keys(this.advancedFilterConfig.config);
      }
    },
    methods: {
      removeFilter(event){
        var id = $(event.currentTarget).prop('id');
        this.$delete(this.filters, id);
      },
      search(){
        // Input field names are tagged as <Entity>@<property>
        // Ex. Customer advanced search fields are tagged like so; Customer@email, Customer@last_name etc
        // this is done so the fields can easily be associated with an entity when sending payload to server
        store.dispatch('toggleLoading');
        var _this = this;
        $( 'input:not(disabled)' ).each(function( index ) {
          if($(this).attr('name') !== undefined){
            var arr = $(this).attr('name').split('@');
            var parentKey = arr[0];
            parentKey = parentKey.toLowerCase();
            var childKey = arr[1];
            _this.payload[parentKey][childKey] = $(this).val();
          }
        });
        $.ajax({
          method: 'POST',
          url: 'http://localhost:5050/jm/api/v2/portal_user/relation-search/',
          data: JSON.stringify(this.payload),
          processData: false,
          contentType: 'application/json',
          success: function(payload){
            store.dispatch('setAdvancedSearchPayload', payload);
            store.dispatch('toggleLoading');
          },
          error: function( jqXhr, textStatus, errorThrown ){
            console.log( errorThrown );
          }
        });
      },
      generateName: function(title, field){
        return title + '@' + _.snakeCase(field);
      },
      snakeCase: function(val){
        return _.snakeCase(val);
      },
      toggleAdvancedFilter(){
        this.$store.dispatch('toggleAdvancedFilter');
      },
    },
};
</script>

<style lang="scss" scoped>
@import "../css/constants";

//Reset container-fluid
.container-fluid {
  margin: 0;
  padding: 0;
}
.from-top{
  margin-top:20px;
}

.select-style select {
  width: 130%;
  border: none;
  box-shadow: none;
  background: transparent;
  background-image: none;
  -webkit-appearance: none;
}

.select-style select:focus {
  outline: none!important;
}
img.remove-filter-img{
  margin-top: 15px;
}
button.advanced-search{
  outline: none;
  background-color: #2c8ada;
  color:white;
  padding:6px;
  border-radius:2px;
  border-color: transparent;
  margin-bottom: 20px;
  margin-top:15px;
}
button.close-advanced-filter{
  background: transparent;
  border: none;
  margin-top: 30px;
  &:focus {
      outline: none;
      box-shadow: none;
  }
}
button.remove-filter{
  background: transparent;
  border: none;

  /*margin-top: 30px;*/
}
select{
  margin-bottom: 5px;
  outline: none;
}
input{
  outline: none;
  border-radius: 2px;
  border: 1px solid lightgray;
}
.static-section{
  margin-top:10px;
}
.advanced-filter-container{
  border-top: 1px solid $gray4;
  border-bottom: 1px solid $gray4;
  margin-left: -$p24;
	padding-left: $p24;
  margin-right: -$p24;
	padding-right: $p24;
}
.advanced-filter-title{
  margin-top:5px;
  margin-bottom: 5px;
  color:grey;
  font-family: 'Khula', sans-serif;
  font-weight: bold;
}
.filter-title{
  border: 1px solid lightgray;
  background-color: white;
  color: grey;
  padding: 5px;
  font-size: 14px;

}
.static-field{
  margin-bottom:10px;
  margin-top:10px;
  padding: 5px;
}
.field{
  margin-bottom:10px;
  padding: 5px;
  width:100%;
}

::-webkit-input-placeholder { /* WebKit, Blink, Edge */
  color: grey;
  font-size: 14px;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color: grey;
  font-size: 14px;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  color: grey;
  font-size: 14px;
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color: grey;
  font-size: 14px;
}
@media (min-width: 576px){
  .col-sm-3 {
    max-width: 23%;
  }
  .select-style {
  border: 1px solid #ccc;
  width: 120px;
  border-radius: 0px;
  overflow: hidden;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding:6px;
  width:100%;
  color:grey;
  background: white url('../assets/angle-arrow-down.svg') no-repeat 95% 50%;
}
}

</style>



// WEBPACK FOOTER //
// src/components/AdvancedFilter.vue